/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation, useRoute} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {
  assuredAgeIsDifferentFromDevis,
  countPersonsInAgeRanges,
  findOldestDate,
  formatDateTo,
  generateUUID,
} from '../../../../common/utils/functions';
import {
  dataConfig,
  initModalData,
} from '../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {ApiResponse} from '../../../../data/types/interface/api';
import {
  IValues,
  ModalDataDTO,
  redoDevisAndContinueDTO,
} from '../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {StackParams} from '../../../../data/types/navigation';
import {VoyageServices} from '../../../../services/applicatif/voyages';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {Header} from '../../../components/Header/HeaderSouscriptionVoyage';
import {itemI} from '../../../components/Inputs/DatePickerModal/MultiDatePicker';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';
import {ConfirmationVoyage} from './Confirmation';
import {Form} from './Forms/FormWeb';

dayjs.extend(customParseFormat);
type NavigationProps = StackNavigationProp<StackParams>;

const FSouscriptionAssuranceVoyageForm = (props: any) => {
  const {
    contratEnCoursUser,
    checkOrangeTransactionUser,
    checkTelmaTransactionUser,
    user,
  } = props;
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {souscrireContrat, postDevis, uploadPassportPhoto} = VoyageServices();

  const [IsLoading, setIsLoading] = useState(false);

  const {params}: any = useRoute();

  const listAgence = React.useMemo(
    () => params.listAgence,
    [params?.listAgence],
  );
  const listCategory = React.useMemo<Array<any>>(
    () => [...params.listCategory],
    [params?.listCategory],
  );

  const initDataDto: IValues = {
    agence: '',
    montant: params?.montant || '',
    dateDebut: params?.dateDebut || '',
    dateFin: params?.dateFin || '',
    category: params?.idCategory || '',
    destination: params?.idDestination || '',
    userIsAssured: false,
    quoteCode: params?.quoteCode,
    assure: [
      ...params?.listNaissance.map((elt: itemI) => ({
        id: elt.id,
        nom: '',
        prenom: '',
        dateNaissance: elt.value,
        lieuNaissance: '',
        email: '',
        telephone: '',
        countryCode: 'MG',
        numPasseport: '',
        datePasseport: '',
        passport_file: undefined,
      })),
    ],
  };
  const [dataDto, setDataDto] = useState<IValues>({...initDataDto});

  const [currentScreen, setCurrentScreen] = useState<'form' | 'validation'>(
    'form',
  );
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [listRes, setListRes] = React.useState<
    Array<{destination: string; montant: string; quoteCode: string}>
  >([]);

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  const initScreen = () => {
    setCurrentScreen('form');
    setListRes([]);
  };

  useEffect(() => {
    checkOrangeTransactionUser('echoue', () => {});
    checkTelmaTransactionUser('echoue', () => {});
    initScreen();
  }, [params]);

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (response: any) => {
    setIsLoading(true);
    souscrireContrat({
      quoteCode: response.quoteCode || params?.quoteCode,
      montant: response.montant,
      agence: response.agence,
      assure: response.assure.map((currentAssure: any) => {
        return {
          first_name: currentAssure.prenom?.trim(),
          last_name: currentAssure.nom?.trim(),
          title: 'M',
          birth_date: formatDateTo(currentAssure.dateNaissance),
          birth_place: currentAssure.lieuNaissance,
          email: currentAssure.email?.trim(),
          passport_number: currentAssure.numPasseport?.trim(),
          datePasseport: formatDateTo(currentAssure.datePasseport),
          phone_number: currentAssure.telephone?.trim(),
          passport_file: currentAssure?.passport_file[0],
        };
      }),
    })
      .then((res: any) => {
        if (res?.data?.id) {
          contratEnCoursUser({
            ...response,
            quoteCode: response.quoteCode || params?.quoteCode,
            typeContrat: 'voyage',
            typePayment: 'souscription',
            simulationId: res.data.id,
          });
          setModalData({
            status: true,
            title: 'Assurance Voyage',
            content:
              'Pour finaliser votre souscription, veuillez procéder au paiement.',
            btn1: 'OK',
            btn2: undefined,
            handleBtn1: () => {
              setModalData({...initModalData});
              redirectToPayment();
            },
            handleBtn2: undefined,
          });
        } else {
          setErrorMessage(res.message);
          setShowErrorModal(true);
        }
      })
      .catch(err => {
        console.log(err);
        setShowErrorModal(true);
        setErrorMessage(err.message || 'Erreur lors de la souscription');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const redoDevisAndContinue = (
    data: redoDevisAndContinueDTO,
    response: any,
  ) => {
    console.log('redoDevis', data);

    postDevis({
      idCategory: parseInt(data.category),
      idDestination: parseInt(data.destination),
      dateDebut: dayjs(data.dateDebut, 'YYYY-MM-DD').toDate(),
      dateFin: dayjs(data.dateFin, 'YYYY-MM-DD').toDate(),
      dateNaissance: data.dateNaissance,
      listNaissance: data.assure.map(a => ({
        id: generateUUID(),
        value: a.dateNaissance as Date,
      })),
    })
      .then((res: ApiResponse) => {
        if (!res.isError) {
          if (res.data.length === 1) {
            setDataDto({
              ...response,
              montant: res.data[0].montant,
              quoteCode: res.data[0].quoteCode,
            });
          } else {
            setDataDto({
              ...response,
            });
            setListRes([
              ...res.data.map((element: any) => ({
                montant: element.montant,
                quoteCode: element.quoteCode,
                destination: element.destination,
              })),
            ]);
          }
          setCurrentScreen('validation');
        } else {
          setErrorMessage(res.message);
          setShowErrorModal(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleGoToValidation = (response: any) => {
    console.log('goToValidation', response);

    const oldest = findOldestDate(response.assure, 'dateNaissance');
    const nbrAges = countPersonsInAgeRanges(
      response.assure,
      {
        childrens: {
          min: dataConfig.ageGap.enfant.min,
          max: dataConfig.ageGap.enfant.max,
        },
        adults: {
          min: dataConfig.ageGap.adult.min,
          max: dataConfig.ageGap.adult.max,
        },
        seniors: {
          min: dataConfig.ageGap.senior.min,
          max: dataConfig.ageGap.senior.max,
        },
      },
      'dateNaissance',
    );
    const oldAges = countPersonsInAgeRanges(
      params?.listNaissance,
      {
        childrens: {
          min: dataConfig.ageGap.enfant.min,
          max: dataConfig.ageGap.enfant.max,
        },
        adults: {
          min: dataConfig.ageGap.adult.min,
          max: dataConfig.ageGap.adult.max,
        },
        seniors: {
          min: dataConfig.ageGap.senior.min,
          max: dataConfig.ageGap.senior.max,
        },
      },
      'value',
      ['DD/MM/YYYY', 'YYYY-MM-DD', '[date]'],
    );
    const currentOldest = findOldestDate(
      response.assure,
      'dateNaissance',
    ).toString();
    const devisOldest = findOldestDate(
      params.listNaissance,
      'value',
    )?.toString();

    if (
      assuredAgeIsDifferentFromDevis(nbrAges, oldAges) ||
      currentOldest !== devisOldest
    ) {
      setIsLoading(true);
      const dataToSend: any = {
        category: response.category,
        destination: response.destination,
        dateDebut: formatDateTo(response.dateDebut).toString(),
        dateFin: formatDateTo(response.dateFin).toString(),
        dateNaissance: formatDateTo(oldest).toString(),
        enfant: `${nbrAges.childrens}`,
        adult: `${nbrAges.adults}`,
        senior: `${nbrAges.seniors}`,
        motif: '',
        assure: response.assure,
      };
      redoDevisAndContinue(dataToSend, response);
      setModalData({...initModalData});
    } else {
      setListRes([]);
      setCurrentScreen('validation');
    }
  };

  const redirectToPayment = () => {
    setModalData({...initModalData});
    navigate('Payement');
  };

  return (
    <View>
      <HeaderScreen
        title="Souscrire assurance voyage"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {modalData.status ? (
          <ConfirmationModal
            title={modalData.title}
            content={modalData.content}
            btn1={modalData.btn1}
            btn2={modalData.btn2}
            handleBtn1={modalData.handleBtn1}
            handleBtn2={modalData.handleBtn2}
          />
        ) : null}
        {showErrorModal ? (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        ) : null}
        {/** Loading */}
        {IsLoading ? <Loader /> : null}
        {/** Header content */}
        {!IsLoading &&
        !modalData.status &&
        !showErrorModal &&
        currentScreen === 'form' ? (
          <Header />
        ) : null}
        {/** Form content */}
        {!modalData.status &&
        !IsLoading &&
        !showErrorModal &&
        currentScreen === 'form' ? (
          <Form
            data={dataDto}
            initData={initDataDto}
            setData={setDataDto}
            listAgence={listAgence}
            onCancelForm={handleCancel}
            onSubmitForm={handleGoToValidation}
          />
        ) : null}
        {!modalData.status &&
        !IsLoading &&
        !showErrorModal &&
        currentScreen === 'validation' ? (
          <ConfirmationVoyage
            data={{
              ...dataDto,
              adresse: user?.data?.utilisateur.adresse,
              destination: params.destinationLabel || '',
              quoteCode: dataDto.quoteCode,
            }}
            category={dataDto.category}
            listType={listRes}
            listCategory={listCategory}
            onCancel={() => setCurrentScreen('form')}
            onSubmit={handleSubmit}
          />
        ) : null}
      </PageContainer>
    </View>
  );
};

export const SouscriptionAssuranceVoyage: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FSouscriptionAssuranceVoyageForm);
